import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const OtpTracking = React.lazy(() =>
    import('../OtpTracking')
);
const otpTrackingRoutesRegistry = [
    {
        path: PAGE_URL.OTP_TRACKING_PAGE,
        element: <OtpTracking />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default otpTrackingRoutesRegistry;
